import './edit-outside-person.scss';
import template from './edit-outside-person.html';

export class EditOutsidePersonController {
  constructor($log, $mdDialog, $mdToast, moment, PinCodeService) {
    'ngInject';
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.moment = moment;
    this.PinCodeService = PinCodeService;

    this.errorMessage = '';
  }

  $onChanges(changes) {
    if (changes.person) {
      this.person = {...this.person};
    }
  }

  save(form) {
    form.$setSubmitted();
    if (form.$invalid) {
      return;
    }

    this.PinCodeService.editAuthorizedOutsidePerson({
      outsidePersonId: this.person.outsidePersonId,
      outsidePersonName: this.person.outsidePersonName,
      outsidePersonLastName: this.person.outsidePersonLastName,
      identificationDocumentNumber: this.person.identificationDocumentNumber,
      phoneNumber: this.person.phoneNumber,
      startDate: this.moment(this.person.startDate).format('YYYY-MM-DD'),
      endDate: this.moment(this.person.endDate).format('YYYY-MM-DD')
    })
      .then(response => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Edytowano osobę uprawnioną')
            .position('bottom right')
            .hideDelay(3000)
        );
        this.$mdDialog.hide(response);
      })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.detailsError({
            locals: {error}
          })
        );
      });
  }

  closeDialog() {
    this.$mdDialog.cancel();
  }
}

export const EditOutsidePerson = {
  bindings: {
    person: '<'
  },
  controller: EditOutsidePersonController,
  template
};
